// extracted by mini-css-extract-plugin
export default {"button":"XUXxtxF8","icon":"uN651IGD"};